import axios from 'axios';
import { API_URL } from '../config/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  if (!token) throw new Error('No hay token de autenticación. Por favor, inicia sesión.');
  return { Authorization: `Token ${token}` };
};

const BASE = `${API_URL}/api/forms-fill`;

export const formsFillApi = {
  listTemplates: () =>
    axios.get(`${BASE}/templates/`, { headers: getAuthHeaders() }).then((r) => r.data),

  listConfigs: () =>
    axios.get(`${BASE}/configs/`, { headers: getAuthHeaders() }).then((r) => r.data),

  updateConfig: (id, data) =>
    axios.patch(`${BASE}/configs/${id}/`, data, { headers: getAuthHeaders() }).then((r) => r.data),

  listJobs: () =>
    axios.get(`${BASE}/jobs/`, { headers: getAuthHeaders() }).then((r) => r.data),

  getJob: (id) =>
    axios.get(`${BASE}/jobs/${id}/`, { headers: getAuthHeaders() }).then((r) => r.data),

  createJob: (formData) =>
    axios.post(`${BASE}/jobs/`, formData, {
      headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data),

  parseJob: (id) =>
    axios.post(`${BASE}/jobs/${id}/parse/`, {}, { headers: getAuthHeaders() }).then((r) => r.data),

  ejecutarJob: (id, { recordId, dryRun } = {}) =>
    axios.post(
      `${BASE}/jobs/${id}/ejecutar/`,
      { record_id: recordId, dry_run: dryRun },
      { headers: getAuthHeaders() },
    ).then((r) => r.data),

  schemaCampos: () =>
    axios.get(`${BASE}/jobs/schema_campos/`, { headers: getAuthHeaders() }).then((r) => r.data),

  updateRecord: (id, data) =>
    axios.patch(`${BASE}/records/${id}/`, data, { headers: getAuthHeaders() }).then((r) => r.data),

  ejecutarRecord: (id, dryRun = true) =>
    axios.post(
      `${BASE}/records/${id}/ejecutar/`,
      { dry_run: dryRun },
      { headers: getAuthHeaders() },
    ).then((r) => r.data),

  desdeEmpresaCliente: (jobId, empresaId) =>
    axios.post(
      `${BASE}/jobs/${jobId}/desde-empresa-cliente/`,
      { empresa_id: empresaId },
      { headers: getAuthHeaders() },
    ).then((r) => r.data),
};
